import { LoadingPlaceholder } from "@communicare/medications/Components/Placeholder";
import React, { useEffect, useState } from "react";
import { Redirect, Route, RouteProps, useParams, useRouteMatch } from "react-router-dom";
import { userService } from "../../../services/authorization/UsersApi";
import { logger } from "../logger";



export const AuthorizedPatientRoute = (props:any)=>{
    
    let [access, setAccess] = useState<'Fetching'|'HasAccess'|'Denied'>('Fetching');
    
    useEffect(()=>{
        let params = props.computedMatch.params;
        if (params) {
            userService.doesUserHaveAccessToResident(params.authoringSystem,params.authoringSystemForeignKey).then(allowed=>{
                if (!allowed) {
                    setAccess('Denied');
                }else{
                    setAccess('HasAccess')
                }
            })    
        }
        
    },[]);

    if (access==='Denied'){
        return <Redirect to={"/no-access"}/>;
    }

    if (access==='Fetching') {
        return <LoadingPlaceholder />;
    }

    return (
        <Route {...props}>
            {props.children}
        </Route>
    );
}